export default {
  getEquipmentWarranties: state =>  {
    return state.equipments
  },
}